import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Alert, Input } from '@wellbeingxltd/fe-lib/components'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { Button, Toolbar } from 'components'
import AuthActions from 'store/models/auth'
import '../styles.scss'

const ConfirmSignup = () => {
    const [confirmationCode, setConfirmationCode] = useState('')
    const [confirmError, setConfirmError] = useState(null)
    const [touched, setTouched] = useState(false)

    const [email, setEmail] = useState(null)
    const [password, setPassword] = useState(null)

    const history = useHistory()
    const dispatch = useDispatch()
    const { loadingConfirmSignUp, loadingResendCode, resendCodeSucceeded, resendCodeFailed, confirmSignUpErrorMessage } = useSelector(GET_STORE.AUTH)

    useEffect(() => {
        const credentialsObj = !!history.location.state ? history.location.state : JSON.parse(localStorage.getItem('confirmSignup'))
        if (credentialsObj === null) {
            history.replace('login')
            return
        }
        const { email, password } = credentialsObj
        setEmail(email)
        setPassword(password)
    }, [])

    useEffect(() => {
        if (resendCodeSucceeded > 0) {
            Alert('A new code has been sent to your email', 'success')
        }
    }, [resendCodeSucceeded])

    useEffect(() => {
        if (resendCodeFailed > 0) {
            Alert('Failed to resend the confirmation code', 'error')
        }
    }, [resendCodeFailed])

    const onConfirmClicked = () => {
        setTouched(true)
        if (confirmationCode.length < 6) {
            if (confirmationCode.length === 0) {
                setConfirmError('*Please enter the confirmation code')
            } else {
                setConfirmError('*Please enter a valid confirmation code')
            }
            return
        }
        dispatch(AuthActions.confirmSignUp(confirmationCode, email, password, history))
    }

    const onNavigationButtonClicked = () => {
        if (history.location.state == null) {
            history.replace('/signup')
        } else {
            history.goBack()
        }
    }

    return (
        <div className="landing-container">
            <Toolbar buttonTitle="Sign up a new supplier" onButtonClicked={onNavigationButtonClicked} />
            <div className="landing-card">
                <h1>Check your email</h1>
                <div className="landing-card-description" style={{ margin: '16px 0 16px 0' }}>
                    We have sent a 6-digit confirmation code to your email. If you haven't received it, please check your junk inbox or try resending
                    the code.
                </div>
                <Input
                    error={confirmError}
                    touched={touched}
                    onFocus={() => {
                        setConfirmError(null)
                        setTouched(false)
                    }}
                    onBlur={() => {
                        setTouched(true)
                    }}
                    value={confirmationCode}
                    onChange={e => {
                        setConfirmationCode(e.target.value)
                    }}
                    labelAbove="Comfirmation code"
                    type="number"
                />
                <Button className="landing-card-button" onClick={onConfirmClicked} loading={loadingConfirmSignUp}>
                    CONFIRM
                </Button>
                {confirmSignUpErrorMessage && <div className="input-error-label">*{confirmSignUpErrorMessage}</div>}
                <div className="landing-card-separator" />
                <div className="landing-card-description" style={{ fontSize: '16px', textAlign: 'center' }}>
                    No code? Click the button below and we'll send another one
                </div>
                <Button
                    className="landing-card-button"
                    onClick={() => {
                        dispatch(AuthActions.resendCode(email))
                    }}
                    loading={loadingResendCode}
                >
                    RESEND CODE
                </Button>
            </div>
        </div>
    )
}

export default ConfirmSignup
